import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import { Outlet, useMatchRoute } from '@tanstack/react-router';
import Logo from 'components/Logo';
import { PageLayoutCancelLink } from 'components/link/PageLayoutCancelLink';

const HeaderStyle = styled('header')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 5, 0),
  },
}));

const OnboarderLayout = () => {
  const matchRoute = useMatchRoute();
  const shouldSignOut = !!matchRoute({ to: '/onboarder/pharmacies' });

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <HeaderStyle>
        <Stack flexDirection="row">
          <Logo />
          <Box style={{ alignSelf: 'flex-end', position: 'relative', bottom: 7 }}>
            <PageLayoutCancelLink
              shouldSignOut={shouldSignOut}
              onSignOutNavigateTo="/login/email"
            />
          </Box>
        </Stack>
      </HeaderStyle>
      <Outlet />
    </Box>
  );
};

export default OnboarderLayout;
